module.exports = __webpack_public_path__ + "static/media/rising.dd42d801.svg";